import { getTimezoneOffset } from 'date-fns-tz';
import { useCallback } from 'react';

export const useGetGmtOffset = () =>
  useCallback(({ timeZone }: { timeZone: string }) => {
    const offsetMinutes = getTimezoneOffset(timeZone, new Date()) / 1000 / 60;

    const sign = offsetMinutes >= 0 ? '+' : '-';
    const abs = Math.abs(offsetMinutes);

    const h = String(Math.floor(abs / 60)).padStart(2, '0');
    const m = String(abs % 60).padStart(2, '0');

    return `GMT${sign}${h}:${m}`;
  }, []);
